var _circle, _circle2, _circle3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63605,
    cy: 2.25,
    r: 2,
    fill: "#151515",
    className: "fill-selector"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63605,
    cy: 8.25,
    r: 2,
    fill: "#151515",
    className: "fill-selector"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63605,
    cy: 14.25,
    r: 2,
    fill: "#151515",
    className: "fill-selector"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.63605,
    y1: 2.25,
    x2: 23.636,
    y2: 2.25,
    stroke: "#151515",
    strokeWidth: 2,
    className: "fill-selector"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.63605,
    y1: 8.25,
    x2: 23.636,
    y2: 8.25,
    stroke: "#151515",
    strokeWidth: 2,
    className: "fill-selector"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.63605,
    y1: 14.25,
    x2: 23.636,
    y2: 14.25,
    stroke: "#151515",
    strokeWidth: 2,
    className: "fill-selector"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.cd82138291e83edfb089177611856290.svg";
export { ForwardRef as ReactComponent };